
import { Navigate } from 'react-router-dom';

const Experts = () => {
  // This acts as the master redirect so users never see a "blank" experts page.
  // It automatically sends them to the first tab (Astrology).
  return <Navigate to="/experts/astrology" replace />;
};

export default Experts;